import { useContext } from 'react';

import { FactsheetOpenStateContext } from './FactsheetOpenStateContextBase';

export const useFactsheetOpenState = () => useContext(FactsheetOpenStateContext);
